<template>
  <div class="section-loading">
    <the-loader size="28" />
  </div>
</template>

<style lang="scss" scoped>
.section-loading {
  position: absolute;
  z-index: 4;
  width: 100%;
  height: 100%;
  margin: -20px;
  background-color: rgba(var(--ui-white-rgb), 0.8);
  border-radius: 20px;
}
</style>
